$('.search-screening-user').keyup(function () {
  let search_screening_user = $(this);
  delay(function () {
    $(search_screening_user).parents('form').submit();
  }, 1000);
});